import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Thinking() {
  const square1 = useRef();
  const square2 = useRef();
  const square3 = useRef();
  const line1 = useRef();
  const line2 = useRef();
  const line3 = useRef();
  const head = useRef();
  const circle = useRef();

  useEffect(() => {
    gsap.to(square1.current, {
      y: "30",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: true,
      ease: "power1.ease",
      repeat: "-1",
      delay: "1",
    });
    gsap.to(square2.current, {
      y: "30",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: true,
      ease: "power1.ease",
      repeat: "-1",
      delay: "2",
    });
    gsap.to(square3.current, {
      y: "30",
      yoyo: "true",
      duration: "1.3",
      yoyoEase: true,
      ease: "power1.ease",
      repeat: "-1",
    });
    gsap.to(line1.current, {
      scaleY: "1.3",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(line2.current, {
      scaleY: "1.3",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(line3.current, {
      scaleY: "1.3",
      repeat: "-1",
      duration: "1.5",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(head.current, {
      y: "-4",
      x: "3",
      repeat: "-1",
      duration: "3",
      ease: "bounce",
      yoyoEase: true,
      yoyo: true,
    });
    gsap.to(circle.current, {
      rotation: "-45",
      repeat: "-1",
      duration: "2",
      ease: "power4",
      yoyoEase: true,
      yoyo: true,
    });
  });

  return (
    <>
      <svg
        width="812"
        height="344"
        viewBox="0 0 812 344"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="thinkingSvg"
      >
        <g id="thinking" clipPath="url(#clip0_0_1)">
          <path
            id="Vector"
            d="M178.229 191.91C178.236 190.854 178.023 189.808 177.604 188.837C177.184 187.866 176.567 186.991 175.79 186.267C175.013 185.543 174.094 184.985 173.089 184.627C172.084 184.27 171.016 184.122 169.951 184.192C168.886 184.261 167.846 184.547 166.898 185.032C165.949 185.517 165.112 186.189 164.438 187.008C163.765 187.827 163.269 188.775 162.982 189.792C162.695 190.809 162.623 191.874 162.771 192.919L140.458 221.819C139.506 223.703 139.137 225.822 139.397 227.912C139.657 230.002 140.535 231.969 141.92 233.568L143.671 235.587L151.702 233.999L160.804 226.056L159.733 217.053L170.976 199.578L170.962 199.566C172.93 199.442 174.777 198.581 176.126 197.159C177.476 195.737 178.228 193.86 178.229 191.91V191.91Z"
            fill="#B06C49"
          />
          <path
            id="Vector_2"
            d="M23.9271 333.197L20.2848 319.818L70.7275 299.558L76.103 319.304L23.9271 333.197Z"
            fill="#B06C49"
          />
          <path
            id="Vector_3"
            d="M11.7434 340.101L0 296.962L0.551676 296.815C5.05416 295.616 9.85373 296.235 13.8947 298.536C17.9357 300.837 20.887 304.631 22.0997 309.084L22.1 309.085L29.2724 335.433L11.7434 340.101Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_4"
            d="M93.4097 331.059L82.0806 322.911L108.469 275.811L125.19 287.838L93.4097 331.059Z"
            fill="#B06C49"
          />
          <path
            id="Vector_5"
            d="M88.313 344L51.7815 317.724L52.1175 317.267C54.86 313.537 58.9881 311.038 63.5938 310.318C68.1995 309.599 72.9055 310.718 76.6768 313.43L76.6777 313.431L98.9899 329.479L88.313 344Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_6"
            d="M189.716 265.242L161.206 237.85C158.717 235.459 155.44 234.037 151.977 233.846C148.513 233.654 145.096 234.706 142.354 236.808L88.5231 295.956L93.3419 303.369L144.741 268.949L179.543 313.96L212.738 297.545L189.716 265.242Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_7"
            d="M177.401 271.067L156.52 269.478L141.398 265.853C140.544 264.535 139.303 263.506 137.842 262.905C136.38 262.304 134.768 262.158 133.221 262.489C131.674 262.819 130.265 263.608 129.184 264.752C128.103 265.895 127.402 267.338 127.173 268.887C126.944 270.436 127.199 272.018 127.903 273.419C128.608 274.821 129.729 275.976 131.116 276.731C132.503 277.485 134.09 277.802 135.664 277.64C137.238 277.477 138.725 276.843 139.925 275.822L139.923 275.833L149.025 279.54L188.11 292.779L192.928 289.072L177.401 271.067Z"
            fill="#B06C49"
          />
          <path
            id="Vector_8"
            d="M227.73 328.259L215.951 335.672H202.03L137.246 311.843L42.4779 328.788L39.801 308.665L126.538 271.067L202.566 295.956L227.73 328.259Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_9"
            d="M256.594 261.382C256.594 273.846 254.608 286.232 250.71 298.085L249.146 302.84L241.651 336.731L233.62 338.849L227.73 331.436L215.951 322.963L207.384 309.195L200.039 297.089L197.747 293.308L189.716 253.592L159.197 236.647L149.025 235.058L151.166 229.233L160.268 217.053L169.37 215.994L172.047 213.876L174.189 214.935L185.995 219.433L224.271 203.439L229.872 204.344L249.146 220.231C254.074 233.403 256.596 247.337 256.594 261.382V261.382Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_10"
            opacity="0.1"
            d="M250.752 256.77L230.407 270.008L200.039 297.089L197.747 293.308L191.322 261.536H192.928L209.526 231.352L250.752 256.77Z"
            fill="black"
          />
          <path
            id="Vector_11"
            d="M209.526 228.174L192.928 258.358L183.291 268.949L174.725 271.067L197.747 295.956L230.407 266.831L250.752 253.592L209.526 228.174Z"
            fill="#CCCCCC"
          />
          <g id="head" ref={head}>
            <path
              id="Vector_12"
              d="M202.566 199.578C214.098 199.578 223.447 190.332 223.447 178.926C223.447 167.52 214.098 158.273 202.566 158.273C191.033 158.273 181.685 167.52 181.685 178.926C181.685 190.332 191.033 199.578 202.566 199.578Z"
              fill="#B06C49"
            />
            <path
              id="Vector_13"
              d="M186.325 163.57L184.062 164.431C183.719 164.201 183.424 163.906 183.196 163.564C182.968 163.221 182.81 162.838 182.731 162.435C182.653 162.032 182.656 161.618 182.739 161.216C182.822 160.814 182.985 160.433 183.218 160.093C183.23 160.075 183.242 160.057 183.255 160.04L179.074 159.846C181.758 156.311 185.17 153.38 189.085 151.246C193 149.113 197.328 147.826 201.784 147.471C206.239 147.116 210.72 147.7 214.93 149.186C219.14 150.672 222.983 153.025 226.204 156.089C226.395 155.441 228.47 156.702 229.317 157.981C229.602 156.926 231.547 162.027 232.235 165.632C232.554 164.432 233.779 166.37 232.706 168.229C233.386 168.131 233.693 169.851 233.166 170.81C233.91 170.464 233.785 172.518 232.978 173.891C234.04 173.798 232.888 195.421 216.958 193.846C215.849 188.806 216.162 189.119 214.856 182.639C214.248 182.001 213.582 181.42 212.918 180.839L209.324 177.702C205.144 174.053 201.342 169.549 195.775 168.186C191.948 167.249 189.529 167.037 191.614 162.773C189.73 163.55 187.971 164.707 186.07 165.429C186.096 164.833 186.361 164.166 186.325 163.57Z"
              fill="#2F2E41"
            />
            <path
              id="Vector_14"
              d="M213.006 185.016C215.076 185.016 216.754 183.356 216.754 181.309C216.754 179.262 215.076 177.602 213.006 177.602C210.936 177.602 209.258 179.262 209.258 181.309C209.258 183.356 210.936 185.016 213.006 185.016Z"
              fill="#B06C49"
            />
          </g>
          <g id="square3" ref={square3}>
            <path
              id="Vector_15"
              d="M38.2292 93.7611L37.0855 110.747L54.2595 111.878L55.4032 94.8923L38.2292 93.7611Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_16"
              d="M27.1486 102.781L48.0027 104.154L46.6139 124.78L25.7598 123.406L27.1486 102.781ZM47.0356 104.991L27.9949 103.737L26.7268 122.569L45.7676 123.823L47.0356 104.991Z"
              fill="#CCCCCC"
            />
          </g>
          <g id="square2" ref={square2}>
            <path
              id="Vector_17"
              d="M135.282 43.3927L118.454 46.969L122.07 63.6127L138.898 60.0364L135.282 43.3927Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_18"
              d="M123.471 35.3312L127.862 55.5414L107.428 59.8839L103.037 39.6737L123.471 35.3312ZM126.782 54.8515L122.773 36.3987L104.116 40.3636L108.125 58.8164L126.782 54.8515Z"
              fill="#CCCCCC"
            />
          </g>
          <g id="square1" ref={square1}>
            <path
              id="Vector_19"
              d="M117.6 123.322L105.038 134.959L116.805 147.384L129.367 135.746L117.6 123.322Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_20"
              d="M130.27 121.581L115.016 135.712L100.728 120.625L115.982 106.494L130.27 121.581ZM115.058 134.442L128.985 121.539L115.94 107.764L102.012 120.667L115.058 134.442Z"
              fill="#CCCCCC"
            />
          </g>
          <path
            id="Vector_21"
            d="M767.232 0H257.976C256.135 -2.06899e-06 254.312 0.358584 252.612 1.05528C250.911 1.75198 249.366 2.77315 248.064 4.06048C246.763 5.34782 245.73 6.87611 245.026 8.55809C244.321 10.2401 243.959 12.0428 243.959 13.8634V294.505C243.959 296.325 244.321 298.128 245.026 299.81C245.73 301.492 246.763 303.02 248.064 304.308C249.366 305.595 250.911 306.616 252.612 307.313C254.312 308.009 256.135 308.368 257.976 308.368H767.232C770.95 308.368 774.515 306.907 777.144 304.308C779.772 301.708 781.249 298.181 781.249 294.505V13.8634C781.249 10.1866 779.772 6.66038 777.144 4.06049C774.515 1.4606 770.95 2.08927e-06 767.232 0V0Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_22"
            d="M761.748 24.4206H262.042V303.219H761.748V24.4206Z"
            fill="white"
          />
          <path
            id="Vector_23"
            d="M512.177 16.8969C515.007 16.8969 517.302 14.6274 517.302 11.8278C517.302 9.02825 515.007 6.75876 512.177 6.75876C509.346 6.75876 507.052 9.02825 507.052 11.8278C507.052 14.6274 509.346 16.8969 512.177 16.8969Z"
            fill="white"
          />
          <path
            id="Vector_24"
            d="M619.549 303.299H262.751V24.5009L619.549 303.299Z"
            fill="#F2F2F2"
          />
          <path
            id="circle"
            d="M340.94 282.436C367.468 282.436 388.973 261.167 388.973 234.929C388.973 208.692 367.468 187.422 340.94 187.422C314.412 187.422 292.907 208.692 292.907 234.929C292.907 261.167 314.412 282.436 340.94 282.436Z"
            fill="#39FF14"
            ref={circle}
          />
          <path
            id="Vector_25"
            d="M351.633 270.635C339.816 270.635 328.264 267.17 318.438 260.676C308.613 254.183 300.955 244.954 296.432 234.155C291.91 223.357 290.727 211.475 293.032 200.012C295.338 188.549 301.028 178.019 309.384 169.755C317.74 161.49 328.386 155.862 339.977 153.582C351.567 151.302 363.58 152.472 374.498 156.945C385.415 161.418 394.747 168.992 401.312 178.71C407.877 188.428 411.382 199.853 411.382 211.541C411.382 219.301 409.836 226.986 406.833 234.155C403.831 241.325 399.43 247.84 393.882 253.327C388.333 258.815 381.747 263.167 374.498 266.137C367.249 269.107 359.479 270.635 351.633 270.635V270.635ZM351.633 153.219C339.97 153.219 328.569 156.64 318.872 163.048C309.175 169.457 301.617 178.565 297.154 189.222C292.691 199.879 291.523 211.606 293.798 222.919C296.074 234.232 301.69 244.624 309.936 252.781C318.183 260.937 328.69 266.492 340.129 268.742C351.567 270.993 363.424 269.838 374.199 265.423C384.974 261.009 394.183 253.534 400.663 243.943C407.142 234.352 410.601 223.076 410.601 211.541C410.601 203.882 409.075 196.298 406.112 189.222C403.149 182.146 398.805 175.717 393.329 170.301C387.854 164.885 381.353 160.59 374.199 157.659C367.044 154.728 359.377 153.219 351.633 153.219L351.633 153.219Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_26"
            d="M646.776 169.344H600.098V178.991H646.776V169.344Z"
            fill="#3F3D56"
          />
          <g id="lines">
            <path
              id="line3"
              d="M690.938 117.082H555.937V121.217H690.938V117.082Z"
              fill="#3F3D56"
              ref={line3}
            />
            <path
              id="line2"
              d="M690.938 133.325H555.937V137.46H690.938V133.325Z"
              fill="#3F3D56"
              ref={line2}
            />
            <path
              id="line1"
              d="M690.938 149.568H555.937V153.703H690.938V149.568Z"
              fill="#3F3D56"
              ref={line1}
            />
          </g>
          <path
            id="Vector_27"
            d="M727.102 41.1854H707.595V60.479H727.102V41.1854Z"
            fill="#39FF14"
          />
          <path
            id="Vector_28"
            d="M736.159 69.4367H712.472V46.0087H736.159V69.4367ZM713.502 68.4181H735.129V47.0274H713.502L713.502 68.4181Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_29"
            d="M795.28 298.23H746.512V294.755C746.512 294.664 746.494 294.575 746.459 294.491C746.424 294.407 746.372 294.331 746.308 294.267C746.243 294.203 746.166 294.153 746.081 294.118C745.997 294.083 745.906 294.066 745.815 294.066H729.094C729.003 294.066 728.912 294.083 728.828 294.118C728.743 294.153 728.666 294.203 728.602 294.267C728.537 294.331 728.486 294.407 728.451 294.491C728.416 294.575 728.398 294.664 728.398 294.755V298.23H717.947V294.755C717.947 294.664 717.929 294.575 717.894 294.491C717.859 294.407 717.808 294.331 717.743 294.267C717.679 294.203 717.602 294.153 717.517 294.118C717.433 294.083 717.342 294.066 717.251 294.066H700.53C700.439 294.066 700.348 294.083 700.264 294.118C700.179 294.153 700.102 294.203 700.038 294.267C699.973 294.331 699.922 294.407 699.887 294.491C699.852 294.575 699.834 294.664 699.834 294.755V294.755V298.23H689.383V294.755C689.383 294.664 689.365 294.575 689.33 294.491C689.295 294.407 689.244 294.331 689.179 294.267C689.115 294.203 689.038 294.153 688.953 294.118C688.869 294.083 688.778 294.066 688.687 294.066H671.966C671.875 294.066 671.784 294.083 671.7 294.118C671.615 294.153 671.538 294.203 671.474 294.267C671.409 294.331 671.358 294.407 671.323 294.491C671.288 294.575 671.27 294.664 671.27 294.755V294.755V298.23H660.819V294.755C660.819 294.664 660.801 294.575 660.766 294.491C660.731 294.407 660.68 294.331 660.615 294.267C660.551 294.203 660.474 294.153 660.389 294.118C660.305 294.083 660.214 294.066 660.123 294.066H643.402C643.311 294.066 643.22 294.083 643.135 294.118C643.051 294.153 642.974 294.203 642.909 294.267C642.845 294.331 642.794 294.407 642.758 294.491C642.723 294.575 642.705 294.664 642.705 294.755V298.23H632.255V294.755C632.255 294.664 632.237 294.575 632.202 294.491C632.167 294.407 632.116 294.331 632.051 294.267C631.986 294.203 631.91 294.153 631.825 294.118C631.741 294.083 631.65 294.066 631.559 294.066H614.838C614.747 294.066 614.656 294.083 614.571 294.118C614.487 294.153 614.41 294.203 614.345 294.267C614.281 294.331 614.229 294.407 614.194 294.491C614.159 294.575 614.141 294.664 614.141 294.755V294.755V298.23H603.691V294.755C603.691 294.664 603.673 294.575 603.638 294.491C603.603 294.407 603.552 294.331 603.487 294.267C603.422 294.203 603.345 294.153 603.261 294.118C603.176 294.083 603.086 294.066 602.994 294.066H586.274C586.182 294.066 586.092 294.083 586.007 294.118C585.923 294.153 585.846 294.203 585.781 294.267C585.717 294.331 585.665 294.407 585.63 294.491C585.595 294.575 585.577 294.664 585.577 294.755V294.755V298.23H575.127V294.755C575.127 294.664 575.109 294.575 575.074 294.491C575.039 294.407 574.988 294.331 574.923 294.267C574.858 294.203 574.781 294.153 574.697 294.118C574.612 294.083 574.522 294.066 574.43 294.066H443.453C443.362 294.066 443.271 294.083 443.187 294.118C443.102 294.153 443.025 294.203 442.961 294.267C442.896 294.331 442.845 294.407 442.81 294.491C442.775 294.575 442.757 294.664 442.757 294.755V294.755V298.23H432.306V294.755C432.306 294.664 432.288 294.575 432.253 294.491C432.218 294.407 432.167 294.331 432.102 294.267C432.038 294.203 431.961 294.153 431.876 294.118C431.792 294.083 431.701 294.066 431.61 294.066H414.889C414.798 294.066 414.707 294.083 414.623 294.118C414.538 294.153 414.461 294.203 414.397 294.267C414.332 294.331 414.281 294.407 414.246 294.491C414.211 294.575 414.193 294.664 414.193 294.755V294.755V298.23H403.742V294.755C403.742 294.664 403.724 294.575 403.689 294.491C403.654 294.407 403.603 294.331 403.538 294.267C403.474 294.203 403.397 294.153 403.312 294.118C403.228 294.083 403.137 294.066 403.046 294.066H386.325C386.234 294.066 386.143 294.083 386.058 294.118C385.974 294.153 385.897 294.203 385.832 294.267C385.768 294.331 385.716 294.407 385.681 294.491C385.646 294.575 385.628 294.664 385.628 294.755V294.755V298.23H375.178V294.755C375.178 294.664 375.16 294.575 375.125 294.491C375.09 294.407 375.039 294.331 374.974 294.267C374.909 294.203 374.833 294.153 374.748 294.118C374.664 294.083 374.573 294.066 374.481 294.066H357.761C357.669 294.066 357.579 294.083 357.494 294.118C357.41 294.153 357.333 294.203 357.268 294.267C357.204 294.331 357.152 294.407 357.117 294.491C357.082 294.575 357.064 294.664 357.064 294.755V294.755V298.23H346.614V294.755C346.614 294.664 346.596 294.575 346.561 294.491C346.526 294.407 346.475 294.331 346.41 294.267C346.345 294.203 346.268 294.153 346.184 294.118C346.099 294.083 346.009 294.066 345.917 294.066H329.197C329.105 294.066 329.015 294.083 328.93 294.118C328.846 294.153 328.769 294.203 328.704 294.267C328.64 294.331 328.588 294.407 328.553 294.491C328.518 294.575 328.5 294.664 328.5 294.755V294.755V298.23H318.05V294.755C318.05 294.664 318.032 294.575 317.997 294.491C317.962 294.407 317.911 294.331 317.846 294.267C317.781 294.203 317.704 294.153 317.62 294.118C317.535 294.083 317.445 294.066 317.353 294.066H300.633C300.448 294.066 300.271 294.138 300.14 294.267C300.009 294.397 299.936 294.572 299.936 294.755V298.23H289.486V294.755C289.486 294.664 289.468 294.575 289.433 294.491C289.398 294.407 289.346 294.331 289.282 294.267C289.217 294.203 289.14 294.153 289.056 294.118C288.971 294.083 288.881 294.066 288.789 294.066H272.069C271.884 294.066 271.707 294.138 271.576 294.267C271.445 294.397 271.372 294.572 271.372 294.755V298.23H239.324C234.89 298.23 230.637 299.972 227.501 303.074C224.366 306.175 222.604 310.381 222.604 314.767V322.245C222.604 326.631 224.366 330.837 227.501 333.939C230.637 337.04 234.89 338.782 239.324 338.782H795.28C799.714 338.782 803.967 337.04 807.103 333.939C810.238 330.837 812 326.631 812 322.245V314.767C812 312.596 811.568 310.445 810.727 308.439C809.887 306.432 808.655 304.609 807.103 303.074C805.55 301.538 803.707 300.32 801.678 299.489C799.65 298.658 797.475 298.23 795.28 298.23V298.23Z"
            fill="#3F3D56"
          />
        </g>
        <defs>
          <clipPath id="clip0_0_1">
            <rect width="812" height="344" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export default Thinking;
